import { Button } from 'reactstrap';
import { CampaignContext } from '~/context/campaign';
import { IPhotoInfo } from '~/types/campaign';
import { renderIcon } from '~/shared/components/icons';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import defaultProfileImg from '~/shared/img/HHLDefault-01.jpg';

export const PhotoCard = ({ hideSidebar }: any) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [{ campaign }, campaignDispatch] = useContext(CampaignContext);
    const [patientInfo, setPatientInfo] = useState(null);
    const [photoInfo, setPhotoInfo] = useState<IPhotoInfo>();
    const history = useHistory();

    useEffect(() => {
        if (campaign) {
            const { campaignDetail, photoInfo, patient } = campaign;
            setLoading(true);
            setPhotoInfo(campaign.campaignPhotoInfo);
            setPatientInfo(patient);
        }
    }, [campaign]);

    if (!photoInfo || !patientInfo) {
        return <div />;
    }

    const showPhoto = () => {
        return (
            <div className='profile-photo-wrap'>
                <div className='profile-photo'>
                    <img
                        src={
                            photoInfo.photo_thumb_url ||
                            photoInfo.photo_url ||
                            defaultProfileImg
                        }
                        alt={`${patientInfo.person.first_name} ${patientInfo.person.last_name}`}
                    />
                </div>
                <Button
                    color='link'
                    onClick={() => {
                        history.push('/patient/edit');
                        hideSidebar();
                    }}
                >
                    {renderIcon('edit')}
                </Button>
            </div>
        );
    };

    return (
        <div className='profile-info'>
            {showPhoto()}
            <div>
                <div className='profile-name'>
                    {`${patientInfo.person.first_name} ${patientInfo.person.last_name}`}
                </div>

                <div className='profile-location'>
                    {`${patientInfo.person.city || ''} ${
                        patientInfo.person.state || ''
                    }`}
                </div>
                <div className='profile-fund'>{photoInfo.fund_name}</div>
            </div>
            <Button
                color='link'
                onClick={() => {
                    history.push('/patient/edit');
                    hideSidebar();
                }}
            >
                {renderIcon('edit')}
            </Button>
        </div>
    );
};
